// @mui material components
import {
  Diversity3Sharp,
  HandshakeSharp,
  SchoolSharp,
} from '@mui/icons-material';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';

import OurVision from 'csdd_components/OurVision';
import caro_another from 'assets/csdd_images/caro_another.png';
import about_us_small from 'assets/csdd_images/about__us__pic__.jpg';

// Material Kit 2 React components
import MKBox from 'components/MKBox';
import MKTypography from 'components/MKTypography';

import { about_us_api } from 'axios_instances';
import { useState } from 'react';

function AboutUsCompo() {
  const [aboutUsTitle, setAboutUsTitle] = useState();
  const [aboutUsBody, setAboutUsBody] = useState();
  const [missionTitle, setMissionTitle] = useState();
  const [ourVisionTitle, setOurVisionTitle] = useState();
  const [ourVisionBody, setOurVisionBody] = useState();
  const [ourValuesTitle, setOurValuesTitle] = useState();

  return (
    <MKBox component='section' py={{ xs: 3, md: 12 }}>
      <Container>
        <MKBox
          minHeight='65vh'
          width='100%'
          sx={{
            borderTopLeftRadius: 30,
            borderBottomLeftRadius: 30,
            backgroundImage: `url(${caro_another})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            display: 'grid',
          }}
        >
          <MKBox
            sx={{
              backgroundColor: 'rgba(128, 5, 0, 0.9)',
              borderTopLeftRadius: 30,
              borderBottomLeftRadius: 30,

              height: '100%',
              width: { xs: '100%', lg: '50%' },
              pt: 10,
              pb: 5,
              px: 7,
            }}
          >
            <MKTypography color='white' variant='h2' mb={5}>
              More About Us
            </MKTypography>
            <MKTypography
              textAlign='justify'
              lineHeight={1.7}
              variant='body2'
              fontWeight='regular'
              color='white'
              mb={2}
            >
              The Chamber of Suppliers Development and Diversity-Africa is
              dedicated to enhancing supplier growth and fostering diversity
              within Ghana's procurement landscape. We provide robust
              development programs and advocate for policies that ensure
              inclusive procurement practices. Through our research and
              networking initiatives, we address the needs and rights of
              suppliers, promoting a fair and competitive marketplace. Our
              efforts aim to build a transparent and excellent procurement
              environment, empowering suppliers to thrive and contribute
              meaningfully to the economy. Join us in our mission to create an
              equitable and dynamic procurement ecosystem in Ghana.
            </MKTypography>
          </MKBox>
        </MKBox>
        <MKBox component='section' py={{ xs: 3, md: 12 }}>
          <Container>
            <Grid container alignItems='center'>
              <Grid item xs={12} lg={5}>
                <Stack>
                  <MKTypography
                    textGradient
                    color='black'
                    textAlign='center'
                    variant='h2'
                    my={1}
                  >
                    Our Mission
                  </MKTypography>
                  <MKBox display='flex' alignItems='center' p={2}>
                    <SchoolSharp color='error' fontSize='large' />
                    <MKTypography variant='body2' color='text' pl={2}>
                      Empowering suppliers particularly micro, small, and medium
                      enterprises (MSMEs) through comprehensive development
                      programs
                    </MKTypography>
                  </MKBox>
                  <MKBox display='flex' alignItems='center' p={2}>
                    <Diversity3Sharp color='error' fontSize='large' />
                    <MKTypography variant='body2' color='text' pl={2}>
                      Advocating for inclusive participation in public and
                      private sector procurement opportunities
                    </MKTypography>
                  </MKBox>
                  <MKBox display='flex' alignItems='center' p={2}>
                    <HandshakeSharp color='error' fontSize='large' />
                    <MKTypography variant='body2' color='text' pl={2}>
                      Championing the needs and rights of suppliers, ensuring a
                      fair and competitive marketplace
                    </MKTypography>
                  </MKBox>
                </Stack>
              </Grid>
              <Grid
                item
                xs={12}
                lg={6}
                sx={{
                  textAlign: 'center',
                  ml: { xs: -2, lg: 'auto' },
                  mt: { xs: 6, lg: 0 },
                }}
              >
                <img
                  style={{
                    borderRadius: '10px',
                    height: '90%',
                    width: '90%',
                    objectFit: 'contain',
                  }}
                  src={about_us_small}
                  alt='Training session by CSDD'
                />
              </Grid>
            </Grid>
          </Container>
        </MKBox>
      </Container>
      <MKBox bgColor='#800500' opacity={0.98}>
        <OurVision />
      </MKBox>
    </MKBox>
  );
}

export default AboutUsCompo;
